import { render, staticRenderFns } from "./PackageEditor.vue?vue&type=template&id=ca9afc2a&scoped=true"
import script from "./PackageEditor.vue?vue&type=script&lang=js"
export * from "./PackageEditor.vue?vue&type=script&lang=js"
import style0 from "./PackageEditor.vue?vue&type=style&index=0&id=ca9afc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9afc2a",
  null
  
)

export default component.exports